import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/login/LoginClient.tsx");
